import React from "react";

import { withRouter } from "react-router-dom";

import AdminService from "../../../services/admin/AdminService";
import MerchantsService from "../../../services/merchants/MerchantsService";

import AdminPage from "./../common/AdminPage";
import Merchant from "@cdkglobal/epay-admin-component/cjs/components/_onePay/middle/merchant/Merchant";

const MerchantPage = ({ history }) => {
  return (
    <AdminPage showGoBackLink={true} history={history}>
      <Merchant
        loadStores={AdminService.getStores}
        loadMerchants={MerchantsService.getMerchants}
        onCreateMerchant={MerchantsService.createMerchant}
        onUpdateMerchant={MerchantsService.updateMerchant}
        onDeleteMerchant={MerchantsService.deleteMerchant}
      />
    </AdminPage>
  );
};

export default withRouter(MerchantPage);
